import { BlogService } from '../services/blogs.service'
import { BlogGetArticleResponse, BlogGetArticlesParams, BlogGetArticlesResponse } from '../types/blog.types'

const blogService = new BlogService()

class BlogRealisation {
    getArticles(params: BlogGetArticlesParams): Promise<BlogGetArticlesResponse> {
        return blogService.getArticles(params)
    }

    getArticle(article_id: number): Promise<BlogGetArticleResponse> {
        return blogService.getArticle(article_id)
    }

    createArticle(payload: FormData): Promise<void> {
        return blogService.createArticle(payload)
    }

    updateArticle(article_id: number, payload: FormData): Promise<void> {
        return blogService.updateArticle(article_id, payload)
    }

    deleteArticle(article_id: number): Promise<void> {
        return blogService.deleteArticle(article_id)
    }
}

export const blog = new BlogRealisation()